const ACTIVATE_GAME_REQUEST = 'EPIC_ACTIVATE_GAME_REQUEST'
const ACTIVATE_GAME_SUCCESS = 'EPIC_ACTIVATE_GAME_SUCCESS'
const ACTIVATE_GAME_FAILURE = 'EPIC_ACTIVATE_GAME_FAILURE'
const SAVE_AUTH_USER = 'EPIC_SAVE_AUTH_USER'
const REMOVE_AUTH_USER = 'EPIC_REMOVE_AUTH_USER'
const SAVE_USER_TICKET_SUCCESS = 'EPIC_SAVE_USER_TICKET_SUCCESS'
const SAVE_USER_TICKET_FAILURE = 'EPIC_SAVE_USER_TICKET_FAILURE'

export default {
  ACTIVATE_GAME_REQUEST,
  ACTIVATE_GAME_SUCCESS,
  ACTIVATE_GAME_FAILURE,
  SAVE_AUTH_USER,
  REMOVE_AUTH_USER,
  SAVE_USER_TICKET_SUCCESS,
  SAVE_USER_TICKET_FAILURE,
}
